import moment from 'moment';

export default function scheduleDateSplitUp(scheduleDate) {
    scheduleDate = scheduleDate ? moment(scheduleDate) : moment((new Date()).getTime() + 1200000)
    return {
        scheduleDate,
        scheduleHour: scheduleDate.format('h'),
        scheduleMinute: scheduleDate.format('mm'),
        scheduleMeridiem: scheduleDate.locale('en').format('A')
    }
};